export const PERMISSION = {
    DASHBOARD_VIEW: 'dashboard_view',
    PROJECT_DASHBOARD : 'project_dashboard',
    PROJECT_DETAILS: 'project_details',
    USER_CREATION : 'user_creation',
    MASTER_CREATION: 'master_creation',
    FORM_CONFIGURATION: 'form_configuration',
    FORM_SUBMISSION: 'form_submission',
    ENTRY_FORM: 'entry_form',
    FORM_LIST: 'form_list',
    FORM_REPORTS: 'form_reports',
    PROJECT_ANALYTICS: 'project_analytics'
}